//GB→MB
export const convertDataSizeUnitGBToMB = (dataSize: number): number => dataSize * 1024;

//MB→GB
export const convertDataSizeUnitMBToGB = (dataSize: number): number => dataSize / 1024;
